import React from "react";
import { gapColorClass } from "./goal-progress-gap";

interface PriorPeriodFooterProps {
    label: string;
    actual: number;
    prior: number;
}

export const PriorPeriodFooter: React.FC<PriorPeriodFooterProps> = ({
    label,
    actual,
    prior,
}) => {
    const delta = actual - prior;
    return (
        <>
            {label}:{" "}
            <span className="font-semibold tabular-nums text-gray-700">{prior}</span>
            <span className={`ml-1 font-semibold ${gapColorClass(actual, prior)}`}>
                ({delta > 0 ? "+" : ""}
                {delta})
            </span>
        </>
    );
};
